import { z } from 'zod';
// ============================================================================
// Order Status Enum
// ============================================================================
/**
 * Order lifecycle status for marketplace orders
 */
export var MKT_OrderStatusEnum;
(function (MKT_OrderStatusEnum) {
    /** Order placed, awaiting acceptance from distributor */
    MKT_OrderStatusEnum["PENDING"] = "PENDING";
    /** Distributor accepted the order */
    MKT_OrderStatusEnum["ACCEPTED"] = "ACCEPTED";
    /** Order has been shipped */
    MKT_OrderStatusEnum["SHIPPED"] = "SHIPPED";
    /** Order delivered successfully */
    MKT_OrderStatusEnum["DELIVERED"] = "DELIVERED";
    /** Order was cancelled */
    MKT_OrderStatusEnum["CANCELLED"] = "CANCELLED";
})(MKT_OrderStatusEnum || (MKT_OrderStatusEnum = {}));
export const MKT_OrderStatusSchema = z.nativeEnum(MKT_OrderStatusEnum);
// ============================================================================
// Fulfillment Status Enum
// ============================================================================
/**
 * Fulfillment tracking status for marketplace orders
 */
export var MKT_FulfillmentStatusEnum;
(function (MKT_FulfillmentStatusEnum) {
    /** No items fulfilled yet */
    MKT_FulfillmentStatusEnum["UNFULFILLED"] = "UNFULFILLED";
    /** Some items have been fulfilled */
    MKT_FulfillmentStatusEnum["PARTIAL"] = "PARTIAL";
    /** All items fulfilled */
    MKT_FulfillmentStatusEnum["FULFILLED"] = "FULFILLED";
})(MKT_FulfillmentStatusEnum || (MKT_FulfillmentStatusEnum = {}));
export const MKT_FulfillmentStatusSchema = z.nativeEnum(MKT_FulfillmentStatusEnum);
// ============================================================================
// Recurring Order Status Enum
// ============================================================================
/**
 * Status for recurring order templates
 */
export var MKT_RecurringStatusEnum;
(function (MKT_RecurringStatusEnum) {
    /** Recurring order is active and will execute on schedule */
    MKT_RecurringStatusEnum["ACTIVE"] = "ACTIVE";
    /** Recurring order is paused, won't execute until resumed */
    MKT_RecurringStatusEnum["PAUSED"] = "PAUSED";
    /** Recurring order has been completed/finished */
    MKT_RecurringStatusEnum["COMPLETED"] = "COMPLETED";
})(MKT_RecurringStatusEnum || (MKT_RecurringStatusEnum = {}));
export const MKT_RecurringStatusSchema = z.nativeEnum(MKT_RecurringStatusEnum);
// ============================================================================
// Recurring Frequency Enum
// ============================================================================
/**
 * Frequency options for recurring orders
 */
export var MKT_RecurringFrequencyEnum;
(function (MKT_RecurringFrequencyEnum) {
    /** Every week (7 days) */
    MKT_RecurringFrequencyEnum["WEEKLY"] = "WEEKLY";
    /** Every 2 weeks (14 days) */
    MKT_RecurringFrequencyEnum["BIWEEKLY"] = "BIWEEKLY";
    /** Every month */
    MKT_RecurringFrequencyEnum["MONTHLY"] = "MONTHLY";
    /** Every 3 months (quarterly) */
    MKT_RecurringFrequencyEnum["QUARTERLY"] = "QUARTERLY";
})(MKT_RecurringFrequencyEnum || (MKT_RecurringFrequencyEnum = {}));
export const MKT_RecurringFrequencySchema = z.nativeEnum(MKT_RecurringFrequencyEnum);
// ============================================================================
// Product Availability Enum
// ============================================================================
/**
 * Product availability status
 */
export var MKT_ProductAvailabilityEnum;
(function (MKT_ProductAvailabilityEnum) {
    /** Product is available for ordering */
    MKT_ProductAvailabilityEnum["IN_STOCK"] = "IN_STOCK";
    /** Limited quantity available */
    MKT_ProductAvailabilityEnum["LOW_STOCK"] = "LOW_STOCK";
    /** Currently unavailable */
    MKT_ProductAvailabilityEnum["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    /** Product is no longer available */
    MKT_ProductAvailabilityEnum["DISCONTINUED"] = "DISCONTINUED";
})(MKT_ProductAvailabilityEnum || (MKT_ProductAvailabilityEnum = {}));
export const MKT_ProductAvailabilitySchema = z.nativeEnum(MKT_ProductAvailabilityEnum);
// ============================================================================
// Recurring Order Rule Type Enum
// ============================================================================
/**
 * Types of rules that can be applied to recurring orders
 */
export var MKT_RecurringRuleTypeEnum;
(function (MKT_RecurringRuleTypeEnum) {
    /** Minimum total order value required */
    MKT_RecurringRuleTypeEnum["MIN_TOTAL"] = "min_total";
    /** Minimum number of items required */
    MKT_RecurringRuleTypeEnum["ITEM_COUNT"] = "item_count";
})(MKT_RecurringRuleTypeEnum || (MKT_RecurringRuleTypeEnum = {}));
export const MKT_RecurringRuleTypeSchema = z.nativeEnum(MKT_RecurringRuleTypeEnum);
// ============================================================================
// Timeline Step Status Enum
// ============================================================================
/**
 * Status for order timeline steps
 */
export var MKT_TimelineStepStatusEnum;
(function (MKT_TimelineStepStatusEnum) {
    /** Step has been completed */
    MKT_TimelineStepStatusEnum["COMPLETED"] = "completed";
    /** Step is currently in progress */
    MKT_TimelineStepStatusEnum["CURRENT"] = "current";
    /** Step is pending/not started */
    MKT_TimelineStepStatusEnum["PENDING"] = "pending";
})(MKT_TimelineStepStatusEnum || (MKT_TimelineStepStatusEnum = {}));
export const MKT_TimelineStepStatusSchema = z.nativeEnum(MKT_TimelineStepStatusEnum);
